<template>
    <div class="pr-0" >
        <v-expansion-panels
            v-if    = "customer"
            v-model = "expand"
            class   = "customer-list"
            :style  = "'max-height:' + (height-10) + 'px'"

            accordion
            flat
        >
            <v-expansion-panel
                class = "pa-0 pr-1"
                v-for = "(item, index) in customer"
                :key  = "item.id"
            >
                <v-expansion-panel-header
                    :ripple     = "false"
                    expand-icon = ""
                    class       = "pa-0"
                    hide-actions
                >
                    <p-dms-treeview-customer
                        :customer = "item"
                        :count    = "unitCount"
                        :selected = "expand && expand === index"
                        @filter   = "onFilter"
                    />
                </v-expansion-panel-header>

                <v-expansion-panel-content
                    class="customer-content"
                >
                    <p-dms-treeview-unit-list
                        class     = "ml-12"
                        :customer = "item"
                        :show-filter = "unitFilter"
                        style     = "width: calc(100% - 44px)"
                        @site     = "onSite"
                        @selected = "onSelected"
                        @units    = "onUnits"
                    />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>

import Core                 from "@/modules/core/service/Core";
import PDmsTreeviewCustomer from "@/modules/dms/treeview/components/private/PDmsTreeviewCustomer.vue";
import PDmsTreeviewUnitList from "@/modules/dms/treeview/components/private/PDmsTreeviewUnitList.vue";

export default {
    name: "PDmsTreeviewCardBody",

    components: {
        PDmsTreeviewUnitList,
        PDmsTreeviewCustomer
    },

    props: {
        customer: {

        },

        height: {

        }
    },

    data: () => ({
        expand: null,
        unitCount: null,
        unitFilter: false,
    }),

    watch: {
        customer () {
            this.unitFilter = false;
        }
    },

    methods: {
        onSite (unit) {
            this.$emit("unit", unit);
        },

        onSelected (unit) {
            Core.fire.selected(this, unit);
        },

        onUnits (units) {
            this.unitCount = units.length;
            console.log("unit count", this.unitCount)
        },

        onFilter () {
            this.unitFilter = !this.unitFilter;
        }

    }
}
</script>

<style scoped>

.customer-list {
    overflow-y: scroll;
    overflow-x: hidden;
    width: calc(100% - 6px);
}

.customer-content {
    border-top-left-radius: 0!important;
    border-top-right-radius: 0!important;
    margin: 0;
    padding: 4px 0 0;
}

</style>